import { render, staticRenderFns } from "./SponsorPostulations.vue?vue&type=template&id=41af758d&"
import script from "./SponsorPostulations.vue?vue&type=script&lang=js&"
export * from "./SponsorPostulations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports